import {
  APP_INITIALIZER,
  LOCALE_ID,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import {  StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ProductEffects } from '../store/effects/product.effects';
import { CartEffects } from '../store/effects/cart.effects';
import { UserEffects } from '../store/effects/user.effects';
import { OrderEffects } from '../store/effects/order.effects';
import { ViewEffects } from '../store/effects/view.effects';
import { AuthService } from '../auth/auth.service';
import { AuthInterceptorService } from '../auth/auth-interceptor';
import { userReducer } from '../store/reducers/user.reducer';
import { productReducer } from '../store/reducers/product.reducer';
import { cartReducer } from '../store/reducers/cart.reducer';
import { viewReducer } from '../store/reducers/view.reducer';
import { orderReducer } from '../store/reducers/order.reducer';
import { CommonModule } from '@angular/common';
import { appInitializer } from './http-initializer/app.initializer';
import { CartService } from '../services/cart.service';
import { CategoriesService } from '../services/categories.service';

@NgModule({
  declarations: [],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    CommonModule,

    // ============================ NGRX ============================//
    StoreModule.forRoot({
      user: userReducer,
      product: productReducer,
      cart: cartReducer,
      view: viewReducer,
      order: orderReducer,
    }),
    EffectsModule.forRoot([
      ProductEffects,
      CartEffects,
      UserEffects,
      OrderEffects,
      ViewEffects,
    ]),
    StoreDevtoolsModule.instrument({
      name: 'VentaDigital',
      maxAge: 25,
      logOnly: false,
    }),
  ],
  providers: [
    AuthService,
    CartService,
    CategoriesService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [AuthService, CartService, CategoriesService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    { provide: LOCALE_ID, useValue: 'es' },
  ],
  exports: [
    FormsModule,
  ],
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule
  ) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import only in AppModule');
    }
  }
}
